import { getSubtleSurfaceBackground } from '@app/core/ui/subtle-surface';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Chip } from '@mui/material';

export interface LiveTopicsNewTopicsPillProps {
  label: string;
  count: number;
  onClick: () => void;
}

/**
 * Floating pill that shows "N temas nuevos" and scrolls to top when clicked.
 * Hidden when count is 0.
 */
export function LiveTopicsNewTopicsPill({ label, count, onClick }: LiveTopicsNewTopicsPillProps) {
  return (
    <Chip
      icon={<KeyboardArrowUpIcon />}
      label={label}
      onClick={onClick}
      color="secondary"
      variant="outlined"
      sx={{
        position: 'absolute',
        top: '16px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: getSubtleSurfaceBackground,
        opacity: count > 0 ? 1 : 0,
        transition: count > 0 ? 'opacity 0.2s ease-in-out' : 'none',
        '&:hover': {
          backgroundColor: 'background.default',
        },
        pointerEvents: count > 0 ? 'auto' : 'none',
      }}
    />
  );
}
